module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-wepay-flow__line",
    class: _vm.classes,
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "weui-wepay-flow__process",
    style: ({
      width: _vm.getWidth(this.processSpan)
    })
  }), _vm._v(" "), (_vm.tip) ? _c('div', {
    class: ("weui-wepay-flow__info-" + _vm.finalTipDirection),
    style: ({
      left: _vm.getWidth(this.processSpan)
    })
  }, [_vm._v(_vm._s(_vm.tip))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b6a03a8"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/flow/flow-line.vue
// module id = 682
// module chunks = 0